'use strict';

import React, {Component} from 'react'
import InputMask from 'react-input-mask';

class PhoneInputMasked extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		return (
			<InputMask className={this.props.className} mask={this.props.mask} value={this.props.value}
			           autoComplete="off" maskChar="_" alwaysShowMask="true"
								 name={this.props.hasOwnProperty('name') ? this.props.name : ''}
			           disabled={this.props.disabled}
			           onChange={this.props.onChange}
			           onBlur={this.props.onChange}
								 data-code={'PHONE'}
								 inputMode="tel"/>
		)
	}
}

export default PhoneInputMasked;